import React from "react";
import { css } from "goober";

import { IS_NODE } from "@/__main__/constants.mjs";
import Static from "@/game-lol/utils/static.mjs";
import { classNames } from "@/util/class-names.mjs";
import { shallowEqual } from "@/util/deep-equal.mjs";

export const ImgTag = () => css`
  aspect-ratio: 1;
  object-view-box: inset(10% 10% 10% 10%);
  border-radius: var(--br-sm);
  /* this is a hack, fixes chrome paint artifact */
  transform: translate3d(0, 0, 0);

  &.round {
    border-radius: 50%;
  }
`;

const globalChampionMap = new Map();

const ChampionImg = (props) => {
  const {
    id,
    championKey,
    championId,
    size = 32,
    className,
    style,
    round = false,
    lazy = false,
    ...rest
  } = props;

  const key = id ?? championId ?? championKey;
  const [memoizedProps, memoizedResult] = globalChampionMap.get(key) ?? [];
  if (memoizedResult && shallowEqual(props, memoizedProps)) {
    return memoizedResult;
  }

  const result = (
    <img
      src={Static.getChampionImage(key)}
      alt=""
      width={size}
      height={size}
      loading={lazy ? "lazy" : "eager"}
      style={style}
      {...classNames(
        ImgTag(),
        className && className,
        round && "round",
        "champion-img",
      )}
      suppressHydrationWarning={rest.suppressHydrationWarning}
      {...rest}
    />
  );

  if (!IS_NODE) {
    globalChampionMap.set(key, [props, result]);
  }

  return result;
};

export default React.memo(ChampionImg);
